<template>
  <div class="rate-of-adv margin-top-10">
    <van-steps :active="active" direction="vertical" active-color="#38f" :active-icon="activeIcon">
      <van-step v-for="(item, index) in param" :key="index">
        <div class="step-name">{{item.stepName}}</div>
        <p class="step-text">{{item.stepRemark}}</p>
        <p v-if="item.noPassReson" class="step-text">退回原因： {{item.noPassReson}}</p>
        <p class="step-text">{{item.createTime}}</p>
      </van-step>
    </van-steps>
  </div>
</template>
<script>
import Vue from 'vue'
import { Notify, Step, Steps, Button } from 'vant'
import { getBusDetailReq } from '@/api/manage'

Vue.use(Step)
Vue.use(Steps)
Vue.use(Button)
export default {
  data () {
    return {
      active: 0,
      activeIcon: 'play-circle',
      param: []
    }
  },
  created () {
    const query = this.$route.query
    const linkedId = query.linkedId

    const params = {
      token: this.$cookies.get('token'),
      openId: this.$cookies.get('openid'),
      linkedId: linkedId
    }
    getBusDetailReq(params).then(response => {
      const res = response.data
      console.log(res)
      if (res.code === 200) {
        this.param = res.data.frontLinkeds
        for (let i = 0; i < this.param.length; i++) {
          if (this.param[i].status === 2) {
            this.active = i
            this.activeIcon = 'underway'
            break
          } else if (this.param[i].status === 1 && i === this.param.length - 1) {
            this.active = i
            this.activeIcon = 'checked'
          }
        }
        this.viewRate(res)
      }
    })
      .catch((res) => {
        Notify({ type: 'danger', message: '获取业务进度失败' })
      })
  },
  methods: {
    // 往父组件传参
    viewRate (msg) {
      this.$emit('paramSend', msg)
    }
  }
}
</script>

<style lang="less" scoped>
  .step-name {
    font-size: 18px;
    font-weight: bold;
  }
  .step-text {
    margin: 5px 0;
    font-size: 15px;
    color: #999;
  }
  .business-button {
    position: absolute;
    top: 0;
    right: 0;
  }
  /deep/ .van-step__title {
    position: relative;
  }
  /deep/ .van-step--vertical {
    padding: 10px 10px 30px 0;
  }
  /deep/ .van-step--vertical:not(:last-child)::after {
    border-bottom-width: 0;
  }
</style>
